module.exports = __webpack_public_path__ + "img/customer_medium@2x.d28ad8be.webp";